import { autoinject } from 'aurelia-framework';
import { DialogController } from "aurelia-dialog";
import { WebApiService } from "../../services/web-api-service";
import 'jquery';
import 'notify';
import { AppMessageService } from '../../services/app-message-service';
import { Carrier } from '../../models/carrier';
import { Equipment } from '../../models/equipment';
import { BusyService } from '../../services/busy-service';

@autoinject
export class RefineMillSearchDialog {
    constructor(
        protected controller: DialogController,
        private api: WebApiService,
        private busyService: BusyService,
        private msg: AppMessageService) {
        this.msg.containerId = "refine-search-carrier-dialog";
    }

    public criteria: CarrierSearchForDivisionUsersCriteria;
    public equipment: Equipment[] = [];

    async activate(params) {

        await this.loadEquipment();

        this.criteria = params.criteria;
    }

    ok() {
        this.controller.ok(this.criteria);
    }

    loadEquipment() {
        this.busyService.on();
        this.api.get("Registration", "GetEquipment")
            .then((result) => {
                this.equipment = JSON.parse(result.response);
            })
            .finally(() => this.busyService.off());
    }
}

export class CarrierSearchForDivisionUsersCriteria {
    public carrierTypes: string[] = ['TRUCKS'];
    public typeOfAuthority: string = "";
    public requiredInsuranceCargo: "" = undefined;
    public equipmentTypeIds: string[] = [];
    public specialtyEquipmentIds: number[] = [];
    public equipmentIds: number[] = []; // used to send data to server, but is calculated value on the client-side
    public heavyHaul = false;
    public haulScrap = false;
    public hazmat = false;
    public diversity = false;
    public excludeNonMasterApproved = true;
    public activeInsurance = false;
    public hasVolume = true;
    public destinationStates: string[] = [];
    public originStates: string[] = [];
    public otherDivisions = true;
    public divisionCode = "";
    public ospCarrierProductGroups = [];
    public showAllPreferredLanes = false;
    public showAllActualLanes = false;
    public showAllEquipmentTypes = false;

}
